<p-sidebar [(visible)]="showMerchantDetailPaymentSideBar"
		   [position]="'right'"
		   [baseZIndex]="10000"
		   (onHide)="cancel()"
		   [style]="{width:'700px'}">
	<ng-template pTemplate="header">
		<div style="margin: 20px 0px 0px 5px;">
			<div class="cs-header-title">Detail payment</div>
		</div>
	</ng-template>

	<div>
		<p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 190px)'}"
					   [styleClass]="'app-scrollpanel'">

			<div class="payment-title">Nominated Payout Account</div>

			<div class="flex flex-row">
				<div class="merchant-column merchant-column-50">
					<div class="merchant-form">
						<div class="merchant-label">Payout Account Type</div>
						<p-dropdown placeholder="Select" [(ngModel)]="payment.PayoutAccountTypeId" [options]="payoutAccountTypes"
									optionLabel="name" optionValue="value" [showClear]="true" [disabled]="true"></p-dropdown>
					</div>
				</div>
				<div class="merchant-column merchant-column-50">
				</div>
			</div>

			<div class="flex flex-row" *ngIf="payment.PayoutAccountTypeId !== undefined && payment.PayoutAccountTypeId === payoutAccountTypeEnum.EWallet">
				<div class="merchant-column merchant-column-50">
					<div class="merchant-form">
						<div class="merchant-label">E-Wallet Details</div>
						<p-dropdown placeholder="Select" [(ngModel)]="payment.WalletDetailId" [options]="walletDetails"
									optionLabel="name" optionValue="value" [showClear]="true" [disabled]="true"></p-dropdown>
					</div>
				</div>
				<div class="merchant-column merchant-column-50">
				</div>
			</div>

			<div class="flex flex-row">
				<div class="merchant-column merchant-column-50">
					<div class="merchant-form">
						<input type="text" [(ngModel)]="payment.AccountName" placeholder="Account Name" pInputText [disabled]="true" />
					</div>
				</div>
				<div class="merchant-column merchant-column-50">
					<div class="merchant-form">
						<input type="text" [(ngModel)]="payment.AccountNumber" placeholder="Account Number" pInputText [disabled]="true" />
					</div>
				</div>
			</div>
		</p-scrollPanel>

		<div class="flex justify-content-end mrg-10-0px">
			<button class="red-btn" pButton label="Remove"></button>
		</div>
	</div>

</p-sidebar>